<template>
  <div>
    <router-view></router-view>
    <AlexChat class="fixed" style="right: 15px; bottom: 15px; z-index: 10" />
<!--    <vs-popup ref="custom_popup" :active="!isUserLoggedIn && activeMarketplace">-->
    <vs-popup ref="custom_popup" :active="popup">
      <div class="p-2">
        <div v-if="!otpSent">
          <h2 class="font-extrabold mb-4">Verify your Email</h2>
          <vx-input-group>
            <vs-input
              v-validate="'required|email|min:3'"
              data-vv-validate-on="blur"
              :disabled="otpSent"
              name="Email"
              icon-no-border
              icon="icon icon-mail"
              icon-pack="feather"
              v-model="email"
              class="w-full mr-3"
            />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  class="btn btn-icon"
                  color="danger"
                  :disabled="!email"
                  @click="sendMeOTP()"
                >
                  <feather-icon icon="LogInIcon" />
                </vs-button>
              </div>
            </template>
          </vx-input-group>
          <span class="text-danger text-sm">{{ errors.first("Email") }}</span>
        </div>
        <div v-else>
          <h2 class="font-extrabold mb-4">Enter OTP</h2>
          <vx-input-group>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="OTP"
              icon-no-border
              icon="icon icon-unlock"
              icon-pack="feather"
              v-model="otp"
              class="w-full mr-3"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  class="btn btn-icon"
                  color="danger"
                  @click="verifyOTP()"
                >
                  Verify
                </vs-button>
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import AlexChat from "./AlexChat";
import { sendMeOTPService, verifyOTPService } from "@/services/auth.service.js";
export default {
  components: {
    AlexChat,
  },
  data() {
    return {
      email: "",
      authPopup: false,
      otp: "",
      popup:false
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    activeMarketplace() {
      return this.$store.state.organization.orgData.activeMarketplace;
    },
  },
  created() {
    const organizationSlug = this.$route.params.organizationSlug;
    if (organizationSlug) {
      this.$store
        .dispatch("organization/fetchOrganizationBySlug", organizationSlug)
        .then((res) => {
          if (!res.data.data[0].activeMarketplace) this.$router.push("/");
          else {
            this.$store.dispatch("alex/fetchUserSegments", { orgId: res.data.data[0]._id});
          }
        })
        .catch((err) => {
          throw err;
        });
      this.email = this.$route.query.email;
    }
  },
  mounted() {
    if (this.isUserLoggedIn) {
      this.popup=false;
      this.$vs.loading();
      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          // // console.log(res.data);
          this.$store.commit(
            "editor/SET_PERSONAL_EVALUATION",
            res.data.personalEvaluation[0]
          );
          this.$store.commit(
            "editor/SET_CAREER_HISTORY",
            res.data.careerHistory
          );
          this.$store.commit(
            "editor/SET_EDUCATIONAL_QUALIFICATIONS",
            res.data.educationalQualifications
          );
          this.$store.commit("editor/SET_PROJECTS", res.data.projects);
          this.$store.commit(
            "editor/SET_EXTRA_CURRICULAR",
            res.data.extraCurricular[0]
          );
          this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);

          this.$store
            .dispatch("alex/fetchDetails", this.$store.state.auth.user._id)
            .catch((err) => {
              throw err;
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        })
        .catch((err) => {
          throw err;
        });
    } else {
      this.$refs.custom_popup.$el.childNodes[1].childNodes[0].style.display =
        "none";
      this.queryUrl = this.$route.query.url;
      if(this.queryUrl){
        this.popup=false;
      }else{
        this.popup=true;
      }
    }
  },
  methods: {
    sendMeOTP() {
      const payload = {
        email: this.email,
        password: this.email,
        currentThis: this,
        userSource: "editor",
      };

      sendMeOTPService(payload);
    },
    verifyOTP() {
      const organizationSlug = this.$route.params.organizationSlug;
      const payload = {
        email: this.email,
        otp: this.otp,
        organizationSlug:organizationSlug,
        currentThis: this,
      };
      this.popup=false;
      verifyOTPService(payload);
    },
  },
};
</script>
